import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "font-bold mb-2Q" }
const _hoisted_3 = { class: "py-5 border-y border-y-neutral-900" }
const _hoisted_4 = { class: "flex justify-between items-center pb-2.5" }
const _hoisted_5 = { class: "font-bold" }
const _hoisted_6 = { class: "flex justify-between items-center" }
const _hoisted_7 = { class: "font-bold" }
const _hoisted_8 = { class: "flex justify-between items-center py-8 md:py-11" }
const _hoisted_9 = { class: "font-bold" }
const _hoisted_10 = { class: "font-bold text-xl md:text-2xl leading-xl" }

import { computed, inject, onMounted, ref } from 'vue';
import ContainerSmall from '../components/layout/ContainerSmall.vue';
import Slider from '../components/form/Slider.vue';
import useBgImage from '../composables/useBgImage';
import Button from '../components/base/Button.vue';
import { AppConfigType } from '../types';
import usePopupWindow from '../composables/usePopupWindow';
import { useRouter } from 'vue-router';
import useSetPageTitle from '../composables/useSetPageTitle';
import { useGettext } from 'vue3-gettext';
import Axios from '~src/shared/axios';
import {useNotificationStore} from '../stores/useNotificationStore';

// Translations
const articlePrice = 1.63;
const taxPrice = 0.37;


export default /*@__PURE__*/_defineComponent({
  __name: 'AddArticles',
  setup(__props) {

const { $gettext } = useGettext();

// Set page title
useSetPageTitle($gettext('Add articles'));

// Get plugin config
const config: AppConfigType = inject('pluginConfig');

// Show notification
const { addNotification } = useNotificationStore();

// Router
const router = useRouter();

// Buy URL
const buyUrl = ref('');

// Set backgroud image on body
useBgImage(config.plugin_url);

// Calculate the price
const selectedArticles = ref(1);
const subtotalPrice = computed(() => {
    return (articlePrice * selectedArticles.value).toFixed(2);
});

const taxPriceComputed = computed(() => {
    return (taxPrice * selectedArticles.value).toFixed(2);
});

// Open payment popup window
const openPaymentPopup = () => {
    usePopupWindow(buyUrl.value, 900, 600, () => {
        // Go to main page
        router.push('/');
    });
};

// Get the buy URL from the API
onMounted(async () => {
	try {
        // Call the WordPress Rest API to get the buy URL
        const response = await Axios.get(`${config.rest.endpoints.boostsite}/generate_stripe_url`);

        // Check if the response is successful
        if (response.status !== 200 || !response.data.success) {
            throw new Error(`REST API error: ${response.status} - ${response.statusText}`);
        }

		if (response.data.data?.url) {
			buyUrl.value = response.data.data.url;
		}
    } catch (error) {
        console.error('Error generating while getting the url:', error);

        addNotification({
            message: $gettext('There was an unexpected error!'),
            type: 'danger',
        });
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ContainerSmall, null, {
    default: _withCtx(() => [
      _createElementVNode("img", {
        width: "139px",
        class: "max-md:mx-auto mb-10",
        src: `${_unref(config).plugin_url}/public/images/boostsite-logo.png`
      }, null, 8, _hoisted_1),
      _createElementVNode("p", _hoisted_2, _toDisplayString(_unref($gettext)('Additional articles')), 1),
      _createVNode(Slider, {
        class: "mb-10",
        modelValue: selectedArticles.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedArticles).value = $event))
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_unref($gettext)('Subtotal')), 1),
          _createElementVNode("p", null, "$" + _toDisplayString(subtotalPrice.value), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", _hoisted_7, _toDisplayString(_unref($gettext)('Tax')), 1),
          _createElementVNode("p", null, "$" + _toDisplayString(taxPriceComputed.value), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("p", _hoisted_9, _toDisplayString(_unref($gettext)('Total due today')), 1),
        _createElementVNode("p", _hoisted_10, "$" + _toDisplayString(selectedArticles.value * (articlePrice + taxPrice)), 1)
      ]),
      _createVNode(Button, {
        class: "w-full mb-10",
        text: _unref($gettext)('Proceed to payment'),
        size: "large",
        onClick: _withModifiers(openPaymentPopup, ["prevent"]),
        loading: buyUrl.value === '',
        disabled: buyUrl.value === ''
      }, null, 8, ["text", "loading", "disabled"])
    ]),
    _: 1
  }))
}
}

})